import { render, staticRenderFns } from "./LandingPageView.vue?vue&type=template&id=c4811fce&scoped=true"
import script from "./LandingPageView.vue?vue&type=script&lang=js"
export * from "./LandingPageView.vue?vue&type=script&lang=js"
import style0 from "./LandingPageView.vue?vue&type=style&index=0&id=c4811fce&prod&scoped=true&lang=scss"
import style1 from "./LandingPageView.vue?vue&type=style&index=1&id=c4811fce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4811fce",
  null
  
)

export default component.exports